import init from '../../../js/init';

const name = 'link-with-modal';
const selector = '.link-with-modal';
const linkSelector = `${selector} button`;
const modalSelector = `${selector} .modal`;

init(Drupal, name, selector, root => {
  const modal = root.querySelector(modalSelector);
  const link = root.querySelector(linkSelector);
  link.addEventListener('click', () => {
    modal.classList.toggle('modal--visible');
    modal.classList.toggle('modal--fade');
    history.pushState({}, '', '#' + root.id);
  });
  if (window.location.hash === ('#' + root.id)) {
    window.scrollTo({
      top: root.offsetTop,
      behavior: 'smooth',
    });
    modal.classList.toggle('modal--visible');
    modal.classList.toggle('modal--fade');
  }
});
